module.exports = __webpack_public_path__ + "assets/img/about-top.83df81c3.png";